// ========================
// Bootstrap 5 Dropdown with Hover and Click
// ========================
import * as bootstrap from "bootstrap";

document.addEventListener("turbo:load", () => {
  // Initialize Bootstrap 5 dropdowns with hover and click
  let currentClickedDropdown = null;
  
  document.querySelectorAll('.dropdown-toggle').forEach(toggle => {
    const dropdown = new bootstrap.Dropdown(toggle, { autoClose: 'outside' });
    const parent = toggle.closest('.dropdown');
    let clickedOpen = false;

    parent.addEventListener('mouseenter', () => {
      if (!clickedOpen) dropdown.show();
    });
    
    parent.addEventListener('mouseleave', () => {
      if (!clickedOpen) dropdown.hide();
    });
    
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Close previously clicked dropdown
      if (currentClickedDropdown && currentClickedDropdown !== toggle) {
        const prevDropdown = bootstrap.Dropdown.getInstance(currentClickedDropdown);
        if (prevDropdown) prevDropdown.hide();
      }
      
      clickedOpen = !clickedOpen;
      if (clickedOpen) {
        dropdown.show();
        currentClickedDropdown = toggle;
      } else {
        dropdown.hide();
        currentClickedDropdown = null;
      }
    });
    
    // Reset clickedOpen when dropdown is hidden by clicking outside
    toggle.addEventListener('hidden.bs.dropdown', () => {
      clickedOpen = false;
      if (currentClickedDropdown === toggle) currentClickedDropdown = null;
    });
  });
});
